export class SystemDivision {
    code: number;
    hid: number;
}



// WEBPACK FOOTER //
// ./src/app/clients/client/header/systemdivision/system-division.model.ts